import { atom } from 'jotai'
import { VideoData } from '../interfaces'

export enum SECONDARY_ACTION {
  NONE,
  BUY,
  SELL,
}

export enum SECONDARY_ORDER {
  NONE,
  LISTINGS,
  OFFERS,
}

export interface SecondaryAction {
  type: SECONDARY_ACTION
  video?: VideoData
  refresh?: SECONDARY_ACTION
}

export interface SecondaryOrder {
  type: SECONDARY_ORDER
  video?: VideoData
}

export interface PurchaseState {
  video?: VideoData
  isOnVideoPage: boolean
}

export const rwBuySellDialogAtom = atom<SecondaryAction>({ type: SECONDARY_ACTION.NONE })
export const rwListingsOffersDialogAtom = atom<SecondaryOrder>({ type: SECONDARY_ORDER.NONE })
export const rwPurchaseDialogAtom = atom<PurchaseState>({ isOnVideoPage: false })
